import React from 'react';

import ActivityWrapper from '../activity-wrapper/activity-wrapper';
import NoteSection from '../note-section';
import bounceRebookedActivityShape from '../../../../../shapes/bounce-rebooked-activity';
import { ACTIVITY_TYPES } from '../../../../../constants';
import { formatUsername } from '../../../../../utils/common/user-utils';

/**
 * Bounce Activity Component
 * @param {object} params - Object containing props
 * @param {object} params.activity - Activity to display
 * @return {element}
 */
const ActivityRebooked = ({ activity }) => {
  // Build header content
  const headerContent = [
    { text: `${formatUsername(activity.initiatorName)} updated the status in TMS`, descriptor: 'Booked' },
    { text: 'New Carrier', descriptor: `${activity.carrierName}` }];

  return (
    <ActivityWrapper
      type={ACTIVITY_TYPES.updateStatusBooked}
      headerContent={headerContent}
      timestamp={activity.eventTime}
      testId="activity-update-status"
    >
      <NoteSection note={activity.note} />
    </ActivityWrapper>
  );
};

ActivityRebooked.propTypes = {
  activity: bounceRebookedActivityShape.isRequired,
};

export default ActivityRebooked;
